<template>
  <div
    class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white transform-translateX(80%)"
    @mouseenter="$sidebar.onMouseEnter()"
    @mouseleave="$sidebar.onMouseLeave()"
    :data="backgroundColor"
  >
    <div class="scrollbar-inner" ref="sidebarScrollArea">
      <div
        class="headerMenu"
        style="height: unset; position: relative; min-height: 60px"
      >
        <div class="navbar-brand">
          <router-link to="/">
            <img
              :src="logo"
              style="
                max-height: unset;
                width: 65.5%;
                margin: 0 auto 20px auto;
                display: block;
              "
              class="navbar-brand-img"
              alt="Sidebar logo"
            />
            <div class="title">
              <span class="form-control-label" style="font-size: 1rem;">Sistema de Gerenciamento</span>
              <span class="form-control-label" style="font-size: 1rem;">de Vendas</span>
            </div>
          </router-link>
        </div>
        <div class="ml-auto" style="position: absolute; top: 0; right: 0">
          <!-- Sidenav toggler -->
          <div
            class="sidenav-toggler d-none d-xl-block"
            :class="{ active: !$sidebar.isMinimized }"
            @click="$sidebar.toggleMinimize()"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
      <div class="navbar-inner" style="margin-left: 4px">
        <ul class="navbar-nav"><slot name="links"></slot></ul>
        <slot name="links-after"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "SGV",
      description: "Sistema de Gerenciamento de Vendas",
    },
    shortTitle: {
      type: String,
      default: "SGV",
      description: "Sistema de Gerenciamento de Vendas",
    },
    logo: {
      type: String,
      default:
        "https://demos.creative-tim.com/vue-argon-dashboard-pro/img/brand/green.png",
      description: "SGV-Logo",
    },
    backgroundColor: {
      type: String,
      default: "vue",
      validator: (value) => {
        let acceptedValues = [
          "",
          "vue",
          "blue",
          "green",
          "orange",
          "red",
          "primary",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar background color (vue|blue|green|orange|red|primary)",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these.",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  mounted() {
    this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.headerMenu {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;

  text-align: center;
  justify-content: center;
}

.title{
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.g-sidenav-hidden {
  width: 20px
}
  

.sidenav-toggler-inner {
  left: 6.8px
}

 
</style>
